<template>
	<div class="publicationList" ref="publications">
		<h2 class = 'my-3'>List of publications with BIƆC contribution</h2>
		<p v-for="pub in sortedPublications" :key="`pub${pub.id}`">
			<span :class="formatAuthor(author)" v-for="(author,authIdx) in pub.all_authors" :key="`${pub.id}${author.lname}${authIdx}`" v-html="`${author.lname} ${author.initials}.${(authIdx!==(pub.all_authors.length-1)?', ':'')}`"></span>
			<strong class="ml-2" v-html="pub.title"></strong> {{pub.year}}. <em v-html='pub.journal'></em> {{getVolumeIssue(pub)}}. <a :href="`https://dx.doi.org/${pub.doi}`" v-if="pub.doi" target="_blank">{{pub.doi}}</a>
		</p>
		<h2 class = 'my-3' v-if="sortedPreprints.length">List of preprints with BIƆC contribution</h2>
		<p v-for="pub in sortedPreprints" :key="`pre${pub.id}`">
			<span :class="formatAuthor(author)" v-for="(author,authIdx) in pub.all_authors" :key="`pre${pub.id}${author.lname}${authIdx}`">{{`${author.lname} ${author.initials}.`}}<span v-if="authIdx!==pub.all_authors.length-1">, </span></span>
			<strong class="ml-2">{{pub.title}}</strong> {{pub.year}}. <em>{{pub.journal}}</em> {{getVolumeIssue(pub)}}. <a :href="`https://dx.doi.org/${pub.doi}`" v-if="pub.doi" target="_blank">{{pub.doi}}</a>
		</p>
	</div>
</template>

<script>
import { HTTP } from '@/router/http.js';
export default {
	name: 'publicationPolicy',
	data () {
		return {
			publications: [],
			preprints: [],
			users: []
		}
	},
	computed: {
		sortedPublications () {
			return _.sortBy(this.publications, p => p.published_at).reverse()
		},
		sortedPreprints () {
			return _.sortBy(this.preprints, p => p.published_at).reverse()
		}
	},
	methods: {
		formatAuthor (author) {
			let idx = _.findIndex(this.users, u => u.lastname.toLowerCase() === author.lname.toLowerCase())
			return (idx > -1) ? "text-primary font-weight-bold" : ""
		},
		getVolumeIssue (pub) {
			let text = ''
			if (pub.volume || pub.issue) text = " (";
			if (pub.volume) text += pub.volume
			if (pub.volume && pub.issue) text += ":"
			if (pub.issue) text += pub.issue
			if (pub.volume || pub.issue) text += ")";
			return text
		}
	},
	mounted () {
		const _this = this
		HTTP.get('/publications').then(res => {
			_this.publications = _.filter(res.data.publications,'doi')
			_this.preprints = _.filter(res.data.preprints,'doi')
		})
		HTTP.get('/usernames').then(res => {
			this.users = res.data
		})
	}
}
</script>

<style scoped>
span.close { 
	cursor: pointer;
}
a.nav-link {
	cursor: pointer;
}
div.project-summary {
	cursor: pointer;
}
h5.project-title, a.nav-category {
	text-transform: capitalize;
}
</style>